const AppUI = (function () {
    let gamesHtml = '';
    let gamesOpened = 0;
    let marginCounter = 1;
    let currentGamesCategory;
    let currentGamesSubCategory;
    let currentTemplate;
    let slideMenu;
    let appData;
    let lastScroll = 0;
    const $body = $('body');
    const $topGamesContainer = $('.big-game .games');
    const $gamesCategories = $('.games-categories');
    const $loadMoreBtn = $('.close-games');
    const LOAD_BY_SCROLL = 3;
    let loadMore = 0;
    let sortedCategoriesMap = false; // Map of game categories
    let sortGameStatus = false;
    const $gamesSort = $('.games-sort');
    const $bonusBalanceMessage = $('.bonus-balance-popup-wrap');
    let lastRenderedCategory;
    let lastRenderedSubCategory = '';
    let isGamesReady = false;
    let platformReady = false;
    const sportClasses = [
        'sport-page',
        'btobet-active',
        'bto-sb-betslip-fixed-open',
        'bto-sb-betslip-fixed-right',
        'bto-sb-betslip-fixed-notifications',
    ];

    const init = function (mainGamesCategory, pageTemplate, data) {
        if ($body.hasClass('has-skeleton')) {
            hideLoadingScreen();
        }

        if (Cookie.read('CookiePolicy')) {
            $body.addClass('cookiePolicyRead');
        }
        if (Player.isRegistered()) {
            $body.addClass('isRegistered');
        }
        currentTemplate = pageTemplate;
        if (AsgApp.isSportActive()) {
            $body.addClass('btobet-active');
        }
        if (isHomePage()) {
            $body.addClass('lobby');
            hideLoadingScreen();
        }

        /**
         * send lobby_open event if on game page or sport page
         */
        AsgUI.fireTriggerIfIsGamePageOrSportPage(pageTemplate);

        appData = data || {};
        fixCanvasAttr();
        checkUserStatusCookie();

        if (AsgApp.isGamePageTemplate()) {
            setNewGamePagePreferences();
        }

        document.addEventListener('dictionaryReady', renderHeader);

        // On 'asgReady' event handler.
        $(document).on('asgReady', function () {
            platformReady = true;
            gamesSearchInit();
            setCookiePolicyEvent();

            // On 'gamesReady' event inside the asgReady event.
            $(document).on('gamesReady', function () {
                isGamesReady = true;
                if (AsgApp.getCurrentVertical()) {
                    renderVerticalContent();
                } else {
                    // Find and remember current active category and sub-category.
                    currentGamesCategory = findActiveGameCategory(mainGamesCategory);
                    currentGamesSubCategory = findActiveGameSubCategory();

                    setGamesCategoriesAsync()
                        .then(() => setInitialGamesGridAsync());
                }

                // Init games categories sort mapping.
                initGameCategoriesMapping();

                // Launch Live Casino feature.
                Games.liveCasinoStart();

                // Changes Google events labels inner content, where there is a Pre/Post text value.
                setTimeout(AsgUI.toggleGAEvents, 50);

                // Render winner tickers (with delay).
                setTimeout(() => {
                    setTickerGamesDataAsync()
                        .then(() => showTickerAsync());
                }, 1000);

                // Load marketing and extra scripts like Freshchat.
                loadMarketingScripsAsync();

                processDirectGamePageLoad(data.gameName);
                processPostLoginPageOpen();

                // load images for game page - it will not be loaded along with games grid
                setTimeout(() => {
                    if (isGamePage()) {
                        loadImages();
                    }
                }, 500);

                // Additional 'LoogedIn' event handler after 'gamesReady' event
                // to process only login event itself and skip every page load.
                $(document).on('LoggedIn', function () {
                    $('body').toggleClass('is-curacao-regulation', AsgApp.isCuracaoRegulation());
                    if (isGamePage()) {
                        openPostLoginGame(data.gameName);
                    }

                    AsgUI.toggleGAEvents();
                });

                // Additional 'LoogedOut' event handler after 'gamesReady' event
                // to process only logout event itself and skip every page load.
                $(document).on('LoggedOut', function () {
                    $('body').toggleClass('is-curacao-regulation', AsgApp.isCuracaoRegulation());
                    if (isGamePage()) {
                        if (!AsgFW.isMobilePamPlatform()) {
                            loadGameInPage(data.gameName, 'D'); // Switch game to Demo mode after login out.
                        } else {
                            $('.game-page-load-game').off('click');
                            $(document).on('click', '.game-page-load-game', function () {
                                AsgApp.loadGame(`${$(this).data('actionInfo').split('|')[0]}|D`);
                            });
                        }
                    }
                });

                // Additional event handler for clicking on More games button.
                $('.close-games').on('click', function () {
                    const category = parseInt($('.games-categories li a.active').attr('class').replace('game-category-', ''), 10);
                    const subcategory = parseInt($('.games-menu-list li.active').attr('id').replace('sub-', ''), 10);
                    gamesAdd(category, subcategory);
                    Games.liveCasinoRefresh();
                });

                if (AsgApp.getCurrentVertical()) {
                    $(document).on('recentGamesUpdated', () => {
                        renderVerticalContent();
                    });
                }
            }); // End on gamesReady event handler.

            // for CMS games - gamesReady event is triggered much faster than asgReady
            // by old architecture. We need to trigger gamesReady event manually
            if (AsgApp.isNeoCmsIntegrationEnabled()) {
                const { app: { platformGamesReady } } = AsgSharedComponents.getState();

                if (platformGamesReady) {
                    AsgApp.applyPlatformDeepLinks();

                    $(document).trigger('gamesReady');
                }
            }

            // TODO remove after include all dependencies in store
            renderHeader();

            hideLoadingScreen();
            innerLinksInit();
            outerContactInit();
            if (isHomePage()) {
                showGameNotAvailableNotification();
            }

            $('.StandardPageLeftSectionContentOL a.ContentLinks').addClass('ready');

            const onPlayButtonClick = (e) => {
                e.stopPropagation();
                if (e.currentTarget.dataset.btnAction) {
                    switch (e.data.buttonType) {
                    case 'promotion':
                        AsgApp.execPromotionCTA(e.currentTarget.dataset);
                        break;
                    default:
                        AsgApp.execBtnAction(e.currentTarget.dataset);
                    }
                } else {
                    AsgApp.playNow();
                }
            };

            $('#main-container').on(
                'click',
                '.playnow-button-link[data-name="promotion-cta-button"]',
                { buttonType: 'promotion' },
                onPlayButtonClick,
            );

            $('#main-container').on(
                'click',
                '.playnow-button-link:not([data-name="promotion-cta-button"]), .playnow-button:not([data-name="promotion-cta-button"])',
                {},
                onPlayButtonClick,
            );

            navigationQuickLinks();

            $('body').toggleClass('is-curacao-regulation', AsgApp.isCuracaoRegulation());

            // Hide new sport loader
            if (AsgApp.isSportActive() && currentTemplate === 'sport-page.php') {
                $('body').removeClass('sport-loader-active');
            }
        });

        $gamesSort.on('click', function () {
            let category = currentGamesCategory;
            let subcategory = currentGamesSubCategory;
            const currentCategorySet = AsgApp.getCurrentCategorySet();
            category = currentCategorySet.categoryId;
            subcategory = currentCategorySet.subCategoryId;
            const sortReverse = !!sortedCategoriesMap[category][subcategory];

            Games.sortGames(sortReverse, category, subcategory);
            $topGamesContainer.html('');
            gamesBuild(category, subcategory).then(() => {
                sortedCategoriesMap[category][subcategory] = !sortReverse;
                sortStateUpdate(sortedCategoriesMap[category][subcategory]);

                sortGameStatus = !sortGameStatus;
                const GAcategory = 'Main Screen';
                const GAaction = (sortGameStatus) ? 'Sort A/Z' : 'Sort Z/A';
                const GAlabel = (Player.isLoggedIn()) ? 'Click sort post login' : 'Click sort pre login';
                AsgApp.GAeventTracking(GAcategory, GAaction, GAlabel);
                Games.liveCasinoRefresh();
            });
        });

        // additional triggers
        $(document).on('LoggedOut', function () {
            switchMenu();
            $('.play-for-real-btn').show();
            setWpInnerSideBanner();
        });
        $(document).on('LoggedIn', function () {
            switchMenu('postLogin');
            menuTitleUpdate();
            setDisplayBalance();
            setLoyaltyPoints();
            AsgApp.getExternalLoyaltyApiData();

            if (InGame.isInGame() && (isGamePage() || isHomePage())) {
                AsgApp.switchToMoneyMode();
                hideLoginBanner();
            }
            setWpInnerSideBanner();
        });
        document.addEventListener('loading', showLoadingScreen);
        $(document).on('showGameSearch', function () {
            $('#main-container')
                .css('height', $(window).height())
                .css('overflow', 'hidden');

            showGameSearch();
            if (AsgFW.isMobilePamPlatform()) {
                addRecentlyPlayedGamesToGrid();
            }
        });
        $(document).on('hideGameSearch', function () {
            $('.search-game').hide();
        });
        $(document).on('bannersReady', function () {
            setPlayerLobbyBanners();

            if (AsgFW.isMobilePamPlatform() && AsgApp.isBrandDK()) {
                $('#mobile-dk-regulation-text').html(`<div class="mobile-dk-regulation-text primary-bgcolor"><a href="/promotions/welcome-package/">${AsgApp.getFullRegulationText()}</a></div>`);
            }
        });

        $(document).on('balanceUpdated', function () {
            setDisplayBalance();
            setLoyaltyPoints();

            // rerender components with balance
            AsgUI.renderStatusBar();
            renderHeader();
            AsgUI.NewHeader.renderStatusBarSubheader();
            Player.setPlayerBalanceToStore();
        });

        $(document).on('startInGame', function (event) {
            $('#in-game-container').show();
            $('.coints ').hide('fast', 'swing');
            $('.user-icon').hide('fast', 'swing');
            $('.account-dropdown').not('body.game-page .account-dropdown').hide('fast', 'swing');
            $('body').not('body.game-page').css('overflow', 'hidden');
            hideLoginBanner();
            $('body').addClass('start-in-game');

            showBonusBalanceMessage();

            if (AsgFW.isMobilePamPlatform()) {
                const body = document.getElementsByTagName('body')[0];
                body.classList.remove('netent-game');
                if (Player.isLoggedIn()
                    && Games.isNetEntGame(event.detail.gameId)
                    && event.detail.playMode === 'M') {
                    body.classList.add('netent-game');
                    Games.gameImprovementsRender();
                }
            } else {
                Games.gameImprovementsRender();
            }
        });
        $(document).on('endInGame', function () {
            if (!InGame.isPassTroughGame()) {
                if (AsgFW.isMobilePamPlatform()
                    || !AsgApp.isGamePageTemplate()
                ) {
                    $('#in-game-container').hide();
                }
                $('.coints').show('fast', 'swing');
                $('.user-icon').show('fast', 'swing');
                $('.account-dropdown').not('.is-mobile .log-out .account-dropdown').show('fast', 'swing');
                $('body').not('body.game-page').css('overflow', 'visible');
                $('body').removeClass('start-in-game');
            }
        });

        $(document).on('fw_bingoRoomOpened, embeddedGameLoadStart', () => {
            const skipMoneyModeCheck = true;
            showBonusBalanceMessage(skipMoneyModeCheck);
        });

        $(window).on('resize', function () {
            fixCanvasAttr();
        });

        if (isHomePage()) {
            if ($loadMoreBtn.length) {
                $(document).on('scroll', function () {
                    // Auto "More Games" load by scrolling
                    if (isInView($loadMoreBtn) && loadMore < LOAD_BY_SCROLL) {
                        loadMore += 1;
                        $loadMoreBtn.trigger('click');
                    } else if (loadMore >= LOAD_BY_SCROLL) {
                        $loadMoreBtn.removeClass('invisible');
                    }
                });
            }
        }

        if (AsgFW.isMobilePamPlatform()) {
            $(document).on('scroll', function () {
                // Show/Hide mobile menus
                const st = $(this).scrollTop();
                const $mainMenu = $('.main-menu-mobile');
                const $gamePageBanner = $('.sticky-mobile-play-for-real-banner');

                if (st > 140 && st > lastScroll) {
                    $mainMenu.addClass('remove-main-menu-mobile');
                    $gamePageBanner.removeClass('scroll-banner-height-fix');
                    $body.addClass('scroll-down');
                } else {
                    $mainMenu.removeClass('remove-main-menu-mobile');
                    $gamePageBanner.addClass('scroll-banner-height-fix');
                    $body.removeClass('scroll-down');
                }
                lastScroll = st;
            });
        }

        specialBenefits();
        Tools.fixAnchorAnimate();

        fixMainContainerMargin();

        // DK promotions short terms link scroll to full T&C
        if (currentTemplate === 'info.php' && $('.dk-short-terms').length > 0) {
            $('.dk-terms-seemore a').on('click', function (e) {
                e.preventDefault();
                const topmenuoffset = AsgFW.isMobilePamPlatform() ? 60 : 100;
                $('html').animate({ scrollTop: $('.toggle-terms-content').offset().top - topmenuoffset }, 'fast');
            });
        }

        loadImages();

        $(document).on('verticalsReady', () => {
            AsgUI.NewHeader.init();

            const verticalContainer = document.getElementById('asg-vertical-container');

            if (verticalContainer) {
                AsgVerticals.renderVerticals({
                    element: verticalContainer,
                });
            } else {
                Tools.log('Vertical container not found');
            }

            // Render Header
            renderHeader();

            if (AsgApp.isSportPageTemplate()) {
                renderSportBanners();
            }
        });
    }; // end AppUI init

    const renderHeader = () => {
        // Render Header
        const headerElement = document.getElementById('asg-vertical-header');
        if (headerElement) {
            AsgVerticals.renderHeader({
                element: headerElement,
                rootLink: appData.rootLink || null,
                propsLeftMenu: getLeftMenuProps(),
                appPromoSmartBanner: getAppPromoSmartBanner(),
                propsSubheaderMenu: {
                    menuItems: getSubheaderMenuProps(),
                },
                isVerticalPage: AsgApp.isVerticalPage(),
            });

            AsgVerticals.services.VerticalService.setVerticalMenuItemMethods({
                setCurrentVerticalId: AsgApp.setCurrentVerticalId,
                setCurrentCategorySet: AsgApp.setCurrentCategorySet,
                gaEventTracking: AsgApp.GAeventTracking,
                afterVerticalChange: renderVerticalContent,
            });
        } else {
            Tools.log('Header container not found');
        }
    };

    const getAppPromoSmartBanner = () => {
        const banners = appData.appPromotingSmartBanners;

        if (!banners.length) {
            return false;
        }

        let bannerToShow = false;

        banners.every(banner => {
            const { slug, maxClosures } = banner;
            const savedMaxClosure = getAppPromoSmartBannerSavedMaxClosures(slug);

            if (savedMaxClosure !== maxClosures) {
                resetAppPromoSmartBannerClosures(slug, maxClosures);
            }

            const currentClosures = getAppPromoSmartBannerClosuresNum(slug);

            if (currentClosures >= maxClosures) {
                return true;
            }

            bannerToShow = banner;
            return false;
        });

        return bannerToShow;
    };

    /**
     * If no stored value, returns 0 to be less than maxClosures.
     * @param slug
     * @returns number
     */
    const getAppPromoSmartBannerSavedMaxClosures = slug => {
        if (localStorage.getItem('appPromoBannerMaxClosures') === null) {
            return 0;
        }

        const syncs = JSON.parse(localStorage.appPromoBannerMaxClosures);
        return slug in syncs ? syncs[slug] : 0;
    };

    const getAppPromoSmartBannerClosuresNum = slug => {
        if (localStorage.getItem('appPromoBannerClosures') === null) {
            return 0;
        }

        const closures = JSON.parse(localStorage.appPromoBannerClosures);
        return slug in closures ? closures[slug] : 0;
    };

    const resetAppPromoSmartBannerClosures = (slug, newMaxClosuresNum) => {
        const maxClosuresJson = localStorage.getItem('appPromoBannerMaxClosures');
        const closuresJson = localStorage.getItem('appPromoBannerClosures');
        const maxClosures = maxClosuresJson ? JSON.parse(maxClosuresJson) : {};
        const closures = closuresJson ? JSON.parse(closuresJson) : {};

        maxClosures[slug] = newMaxClosuresNum;
        closures[slug] = 0;

        localStorage.setItem('appPromoBannerMaxClosures', JSON.stringify(maxClosures));
        localStorage.setItem('appPromoBannerClosures', JSON.stringify(closures));
    };

    const renderSportBanners = () => {
        const verticalBannersPortal = document.getElementById('asg-vertical-banners-portal');

        if (verticalBannersPortal) {
            AsgVerticals.renderSportBanners({
                element: verticalBannersPortal,
            });
        }
    };

    const processDirectGamePageLoad = (gameName) => {
        const openGame = (name, mode) => {
            if (!AsgFW.isMobilePamPlatform()) {
                loadGameInPage(name, mode);
            } else if (AsgFW.isMobilePamPlatform()) {
                setGameIdInPage(name, mode);
            }
        };

        if (isGamePage()) {
            // no direct game pages for logged in
            if (Player.isLoggedIn()) {
                return AsgApp.redirectToLobby();
            }

            const withNotification = true;
            AsgApp.redirectPageGameIfGameNotExist(gameName, withNotification);
            openGame(gameName, 'D');
        }
    };

    const processPostLoginPageOpen = () => {
        if (AsgFW.isLoggedIn() && isHomePage()) {
            const gameName = Cookie.read(AsgApp.cookieNames.OPEN_POST_LOGIN_GAME_PAGE);
            Cookie.remove(AsgApp.cookieNames.OPEN_POST_LOGIN_GAME_PAGE, '/');
            if (!gameName) {
                return;
            }

            loadGameInPage(gameName, 'M');
        }
    };

    const openPostLoginGame = (gameName) => {
        Cookie.create(AsgApp.cookieNames.OPEN_POST_LOGIN_GAME_PAGE, gameName, '180', '/');
        AsgApp.redirectToLobby();
    };

    const showGameNotAvailableNotification = () => {
        if (
            Cookie.read(AsgApp.cookieNames.GAME_NOT_AVAILABLE_NOTIFICATION)
            && GameNotAvailableMessage
        ) {
            GameNotAvailableMessage.show();
            Cookie.remove(AsgApp.cookieNames.GAME_NOT_AVAILABLE_NOTIFICATION, '/');
        }
    };

    const fixMainContainerMargin = function () {
        if ($('.main-menu-mobile').length > 0) {
            let paddingTop;
            if ($('body').hasClass('status-bar-active')) {
                paddingTop = '78px';
            } else {
                paddingTop = AsgApp.isSportPage() ? '13px' : '52px';
            }
            $('#main-container').css('margin-top', paddingTop);
        }
    };

    const addRecentlyPlayedGamesToGrid = function () {
        const rgl = JSON.parse(Cookie.read('recentGamesList'));
        const gamesListDiv = $('.games-list');
        const recentTitle = $('.recent');
        const gamePartial = AsgFW.isMobilePamPlatform() ? 'game_search_item_mobile' : 'game_item';
        if (rgl != null) {
            recentTitle.show();
            gamesListDiv.empty();
            gamesListDiv.show();
            rgl.forEach(recentGame => {
                const game = Games.getGameById(recentGame);
                if (game && game.name) {
                    let htmlGameRepresentation = Games.searchGameByName(
                        game.name,
                        true,
                        true,
                        gamePartial,
                        false,
                    );
                    htmlGameRepresentation = $(htmlGameRepresentation).not('.results-count');
                    gamesListDiv.append(htmlGameRepresentation);
                    attachGamesThumbsEvents();
                    loadImages();
                }
            });
        } else {
            recentTitle.hide();
        }
    };

    // Event handler - on user has just logged in or has just logged out.
    $(document).on('justLoggedIn justLoggedOut', function () {
        // Event handler for 'gameUpdateFinished' - games were got from NG and processed by ASG.
        $(document).one('gameUpdateFinished', function () {
            if (isHomePage()) {
                if (AsgApp.getCurrentVertical()) {
                    renderVerticalContent().then();
                } else {
                    // Find and remember current active category and sub-category.
                    currentGamesCategory = findActiveGameCategory(currentGamesCategory);
                    currentGamesSubCategory = findActiveGameSubCategory();

                    setGamesCategoriesAsync()
                        .then(() => setInitialGamesGridAsync());
                }
            }
        });
        // TODO remove after include all dependencies in store
        renderHeader();
    });

    function hideLoginBanner() {
        if (Player.isLoggedIn()) {
            $('.play-for-real-btn').hide();
        }
    }

    const showBonusBalanceMessage = (skipGameModeCheck = false) => {
        let isMoneyMode = InGame.getGameMode() === 'M';
        if (skipGameModeCheck) {
            isMoneyMode = true;
        }

        const currentRegulation = AsgFW.getRegulation().toUpperCase();
        const showMessageOnRegulations = ['MGA', 'GB'];

        if (
            AsgApp.getDisplayBalance().BonusBalance > 0
            && !AsgFW.isMobilePamPlatform()
            && (showMessageOnRegulations.includes(currentRegulation))
            && isMoneyMode
        ) {
            $bonusBalanceMessage.addClass('show-bonus-balance-popup');
            setTimeout(() => {
                $bonusBalanceMessage.removeClass('show-bonus-balance-popup');
            }, AsgApp.getBonusMessageTimeout());
        } else {
            $bonusBalanceMessage.removeClass('show-bonus-balance-popup');
        }
    };

    const setCookiePolicyEvent = function () {
        if (!AsgApp.getIsOneOfNativeApps()) {
            $(document).on('showCookiePopup', function () {
                $('.cockie-popup-wrap').addClass('show-cookie-popup');
            });

            $('.cockie-popup-close').on('click', function () {
                $('.cockie-popup-wrap').removeClass('show-cookie-popup');
                Cookie.create('CookiePolicy', 1, '180', '/');
                $('body').addClass('cookiePolicyRead');
            });
        }
    };

    const isSmallDevice = function () {
        return window.innerWidth < 1024;
    };

    const fixCanvasAttr = function () {
        const mainContainerSelector = $('#main-container');
        if (!isSmallDevice() || AsgApp.isGamePageTemplate()) {
            mainContainerSelector.attr('data-canvas', '');
            mainContainerSelector.removeAttr('data-canvas');
        } else {
            mainContainerSelector.attr('data-canvas', 'container');
        }
    };

    const checkUserStatusCookie = function () {
        if (AsgApp.checkUserStatusCookie()) {
            // postLogin
            $('.prom-buttons .play-now .log-in').hide();
            $('.prom-buttons .play-now .log-out').show();
        } else {
            // preLogin
            $('.prom-buttons .play-now .log-out').hide();
            $('.prom-buttons .play-now .log-in').show();
        }
    };
    const initGameCategoriesMapping = function () {
        if (AsgApp.isNeoCmsIntegrationEnabled()) {
            return;
        }

        sortedCategoriesMap = Games.getCategories()
            .map(category => category)
            // map() should return array of undefined = length of subcategories
            .map(sub => sub.subCategories.map(() => undefined));

        if (AsgFW.isMobilePamPlatform()) {
            // Add extra category for Recent games
            sortedCategoriesMap.push([undefined]);
        }
        sortStateUpdate();
    };

    const sortStateUpdate = function (state) {
        if (state !== undefined) {
            $gamesSort.addClass('active');
        } else {
            $gamesSort.removeClass('active');
            $gamesSort.find('.arrow').hide();
            return;
        }

        if (state) {
            $gamesSort.find('.arrow-down').hide();
            $gamesSort.find('.arrow-up').show();
        } else {
            $gamesSort.find('.arrow-down').show();
            $gamesSort.find('.arrow-up').hide();
        }
    };

    const getLeftMenuProps = () => {
        const leftMenuData = AsgApp.getLeftMenuData();

        return {
            userData: {
                accountName: AsgFW.getPlayerName(),
            },
            welcomeEmojiCode: leftMenuData.welcomeEmojiCode,
            welcomeText: leftMenuData.title,
            brandName: AsgFW.getBrandName(),
            promotionsCount: sessionStorage.getItem('promotionsVisited') === 'true'
                ? null : AsgApp.getAllPromotionsNumber(),
            languages: leftMenuData.langs,
            showExclusiveClub: !AsgFW.isHideLoyaltyPageFlag() && !AsgApp.isSingleVerticalTypeBrand('sport'),
            balanceAmounts: AsgApp.getBalanceFoldData(),
        };
    };

    const getSubheaderMenuProps = () => {
        const menuItems = [];

        if (AsgApp.isPromotionPage() && AsgApp.isLtPromotionsEnabled()) {
            const promotionsLink = '/promotions';
            menuItems.push({
                text: Dictionary.translate('promotions'),
                handler: AsgApp.navigateTo.bind(null, promotionsLink, null, null),
                notification: sessionStorage.getItem('promotionsVisited') === 'true'
                    ? null : AsgApp.getAllPromotionsNumber(),
            });
            if (window.breadcrumbs) {
                menuItems.push({
                    text: window.breadcrumbs,
                    active: true,
                });
            }
        } else {
            if (AsgFW.getRbcSettings('isPromotionsAvailable')) {
                const promotionsLink = '/promotions';
                menuItems.push({
                    text: Dictionary.translate('promotions'),
                    active: location.href.includes(promotionsLink),
                    handler: AsgApp.navigateTo.bind(null, promotionsLink, null, null),
                    notification: sessionStorage.getItem('promotionsVisited') === 'true'
                        ? null : AsgApp.getAllPromotionsNumber(),
                });
            }

            if (!AsgFW.isHideLoyaltyPageFlag() && !AsgApp.isSingleVerticalTypeBrand('sport')) {
                const loyaltyLink = '/loyalty';
                menuItems.push({
                    text: Dictionary.translate('exclusiveClub'),
                    active: location.href.includes(loyaltyLink),
                    handler: AsgApp.navigateTo.bind(null, loyaltyLink, null, null),
                });
            }

            menuItems.push(getSubHeaderHelpMenu());
        }

        return menuItems;
    };

    const getSubHeaderHelpMenu = () => {
        // if not Action247 brand
        if (AsgFW.getBrandID() !== '740') {
            return {
                text: Dictionary.translate('help'),
                active: false,
                handler: () => AsgApp.openInfoPopup('faq.aspx', new Event('click')),
            };
        }

        const helpSubMenu = [
            {
                text: Dictionary.translate('faqFull'),
                handler: () => {
                    AsgApp.openInfoPopup('faq.aspx', new Event('click'));
                },
            },
        ];

        if (AsgFW.isLoggedIn() || !AsgFW.chatRequiresLogin()) {
            helpSubMenu.push({
                text: Dictionary.translate('chatWithUs'),
                handler: AsgFW.showChat,
            });
        }

        helpSubMenu.push({
            text: Dictionary.translate('contactUs'),
            handler: AsgApp.navigateTo.bind(null, '/contact-us', null, null),
        });

        return {
            text: Dictionary.translate('help'),
            active: false,
            submenu: helpSubMenu,
        };
    };

    const loadImages = function () {
        $('[data-original]').each(function () {
            const image = $(this)[0];
            const targetUrl = $(image).data('original');

            if (targetUrl === image.src) {
                return;
            }

            const downloadImage = new Image();
            downloadImage.decoding = 'async';
            image.loading = 'lazy';
            downloadImage.onload = function () {
                image.src = this.src;
            };

            downloadImage.src = targetUrl;
        });
    };

    /**
     * Returns the subcategory number.
     * @returns {null|*}
     */
    const findActiveGameSubCategory = function () {
        // If BuyWin is active - force use BuyWin as the default sub-category.
        if (AsgApp.isGermanyBuyWinActive()) {
            return Games.getDefaultSubCategory(currentGamesCategory);
        }

        // If there is an active (chosen) sub-category on the page or the predefined one.
        const currentSubCategory = $('.games-menu-list li.active');
        const categories = Games.getCategories();
        if (currentSubCategory.length < 1) {
            const detectedSubCatFromUrl = detectSubCatFromUrl();
            return (!AsgFW.isMobilePamPlatform()
                && detectedSubCatFromUrl
                && typeof categories[currentGamesCategory] !== 'undefined'
                && typeof categories[currentGamesCategory].subCategories[detectedSubCatFromUrl] !== 'undefined')
                ? detectedSubCatFromUrl
                : Games.getDefaultSubCategory(currentGamesCategory);
        }
        const activeSubCategoryName = currentSubCategory.contents().eq(0).text().trim();
        const activeSubCategoryIndex = categories[currentGamesCategory].subCategories
            .findIndex((el) => el.name === activeSubCategoryName);
        return (activeSubCategoryIndex !== -1
            ? activeSubCategoryIndex
            : Games.getDefaultSubCategory(currentGamesCategory)
        );
    };

    /**
     * Returns the main category number.
     * @param mainGamesCategory - default value from BE '-1'.
     * @returns {number}
     */
    const findActiveGameCategory = function (mainGamesCategory) {
        // If BuyWin is active - force use BuyWin as the default category.
        if (AsgApp.isGermanyBuyWinActive()) {
            return Games.getDefaultCategory();
        }

        // If there is an active (chosen) category on the page.
        const activeFlag = $gamesCategories.find('li > .active');
        const categories = Games.getCategories();
        if (activeFlag.length > 0) {
            const activeCategoryName = $(activeFlag[0]).contents().eq(0).text()
                .toUpperCase();
            const activeCategoryIndex = categories.findIndex((el, i) => categories[i].name
                .toUpperCase() === activeCategoryName);
            return (activeCategoryIndex !== -1) ? activeCategoryIndex : Games.getDefaultCategory();
        }

        // The default option - to use a predefined category form WP
        // or detect the default category from NG.
        return (mainGamesCategory !== -1 && typeof categories[mainGamesCategory] !== 'undefined')
            ? mainGamesCategory
            : Games.getDefaultCategory();
    };

    const gamesSubCategoriesOnClick = function () {
        $('.games-menu-list li').on('click', function () {
            const category = parseInt($gamesCategories.find('li a.active').attr('class').replace('game-category-', ''), 10);
            const subcategory = parseInt($(this).attr('id').replace('sub-', ''), 10);

            // Prevent unnecessary subcategory re-render.
            const subcategoryKey = Games.getSubCategoryKey(category, subcategory);
            if (lastRenderedSubCategory === subcategoryKey) {
                $(`.games-menu-list #sub-${subcategory}`).addClass('active');
                return null;
            }
            lastRenderedSubCategory = subcategoryKey;

            // Mark chosen (clicked) sub-category as the active one.
            currentGamesSubCategory = subcategory;
            $('.games-menu-list li').removeClass('active');
            $(`.games-menu-list #sub-${subcategory}`).addClass('active');

            if ($('.games-menu-list').css('position') === 'fixed') {
                $('html, body').animate({
                    scrollTop: 278,
                }, 300);
            }

            // Build the games grid for the chosen sub-category.
            gamesBuild(category, subcategory).then(() => {
                sortStateUpdate(sortedCategoriesMap[category][subcategory]);
                Games.hideSortForRecents($(this)[0].childNodes[0].nodeValue.trim());

                // Refresh Live casino.
                Games.liveCasinoRefresh();
            });
        });
    };

    const gamesCategoriesOnClick = function () {
        $gamesCategories.find('li a:not(.default-event)').on('click', function (evt) {
            if (currentTemplate === 'page.php') {
                const category = parseInt($(this).attr('class').replace('game-category-', ''), 10);
                let subcategory;

                // Prevent unnecessary category re-render and default behaviour.
                evt.preventDefault();

                // Close opened game.
                if (InGame.isInGame()) {
                    if (!evt.isTrigger) {
                        AsgApp.closeGame();
                    }
                }

                // Mark chosen (clicked) category as the active one.
                $gamesCategories.find('li a').removeClass('active');
                $(`.${$(this).attr('class')}`).addClass('active');
                setCookieCaretCategory(category);

                // Render sub-categories of the chosen category.
                setGamesSubCategories(category);

                // Force to open a predefined in WP or default sub-category of the chosen category.
                if (!AsgFW.isMobilePamPlatform()
                    && (lastRenderedCategory === category || lastRenderedCategory === undefined)) {
                    subcategory = currentGamesSubCategory;
                } else {
                    subcategory = Games.getDefaultSubCategory(category);
                }
                $(`#sub-${subcategory}`).trigger('click');

                // Mark current category.
                currentGamesCategory = category;
                lastRenderedCategory = category;

                AsgUI.toggleGAEvents();
            }
        });

        $gamesCategories.find('li a').on('click', function () {
            const classes = $(this).attr('class').substr('game-category-');
            const category = classes.substr(0, classes.indexOf(' ')).replace('game-category-', '');

            if (category.indexOf('sport') > -1) {
                setCookieCaretCategory('sport');
            } else {
                setCookieCaretCategory(category);
            }
        });
    };

    /**
     * close full screen and close game
     */
    $('.game-improvements-in-game-close').on('click', function () {
        if (!AsgApp.isFullScreenCurrently()) {
            AsgApp.goOutFullscreen();
        }
        AsgApp.closeGame(true);
    });

    /**
     * Render main categories (main verticals) menu.
     */
    const setGamesCategories = function () {
        let html = '';
        let categories = Games.getCategories();

        // If mobile and Recent is not already exists.
        if (AsgFW.isMobilePamPlatform() && categories.slice(-1)[0].name.toLowerCase() !== Dictionary.translate('recent').toLowerCase()) {
            categories = Games.addRecentGamesCategories(categories, Games.getDefaultCategory() + 1);
        }
        let i = 0;
        categories.forEach(function (cat) {
            const extraElement = cat.extraElement || null;
            html += Games.generateCategoryItem(cat.name, i, currentTemplate, extraElement);
            i += 1;
        });

        // Show mobile main verticals menu.
        if ($body.hasClass('has-skeleton')) {
            $gamesCategories.html('');
        }

        // Render main categories menu.
        $gamesCategories.html(html);

        // Add Sport menu item to the main categories menu.
        const sportCatName = Dictionary.translate('sport');
        const sportLink = AsgApp.getSportSlug();
        if (AsgApp.isSportActive()) {
            const activeClass = currentTemplate === 'sport-page.php' ? 'active' : '';
            $('nav.navbar .games-categories').append(`<li><a class="game-category-sport default-event ${activeClass}" href="/${sportLink}/">${sportCatName}</a><li>`);
        }

        // Add categories onclick event handler.
        gamesCategoriesOnClick();
    };

    const detectSubCatFromUrl = function () {
        const getSubCategoryFromUrl = Tools.getParameters(Tools.getNavUrl());
        return (Object.prototype.hasOwnProperty.call(getSubCategoryFromUrl, 'sub-category'))
            ? getSubCategoryFromUrl['sub-category']
            : null;
    };

    /**
     * Async wrapper for @setGamesCategories()
     * @returns {Promise<unknown>}
     */
    const setGamesCategoriesAsync = function () {
        return new Promise((resolve) => {
            setTimeout(function () {
                setGamesCategories();
                resolve();
            }, 50);
        });
    };

    const setInitialGamesGridAsync = function () {
        return new Promise((resolve) => {
            setTimeout(function () {
                // As we have 2 main category menus on the page
                // choose the correct menu by platform to avoid double render.
                const mainCatsMenuIndex = AsgFW.isMobilePamPlatform() ? 0 : 1;

                // Force click on the main category menu item
                // to start initial subcategories and main games grid render.
                $(`.game-category-${currentGamesCategory}`).eq(mainCatsMenuIndex).trigger('click');

                // Activate Sport page mode.
                if (currentTemplate === 'sport-page.php') {
                    setCookieCaretCategory('sport');
                    currentGamesCategory = 'sport';
                }

                resolve();
            }, 50);
        });
    };

    const setTickerGamesDataAsync = function () {
        return new Promise((resolve) => {
            setTimeout(function () {
                setTickerGamesData();
                resolve();
            }, 50);
        });
    };

    const showTicker = function () {
        if (AsgFW.isMobilePamPlatform()) {
            const tickerCount = $('.mobile-winner-ticker-wrap .item').length;
            if ($body.hasClass('has-skeleton')) {
                $('.ticker-skeleton').remove();
            }
            if (tickerCount <= 1) {
                $('.mobile-winner-ticker-wrap').show();
                $('.mobile-winner-ticker-wrap').addClass('oneWinners');
            } else if (tickerCount === 2) {
                $('.mobile-winner-ticker-wrap').show();
                $('.mobile-winner-ticker-wrap').addClass('twoWinners');
            } else if (tickerCount === 3) {
                $('.mobile-winner-ticker-wrap').show();
                $('.mobile-winner-ticker-wrap').addClass('ticketWithOutCarousel');
            } else {
                $('.mobile-winner-ticker-wrap').show();

                // delay winners slider as it is not critical for page load
                setTimeout(mobileWinnerTickerInit, 2000);
            }
        }
    };

    const showTickerAsync = function () {
        return new Promise((resolve) => {
            setTimeout(function () {
                showTicker();
                resolve();
            }, 50);
        });
    };

    const loadMarketingScripsAsync = function () {
        return new Promise((resolve) => {
            setTimeout(function () {
                AsgApp.loadExtraScripts();
            }, 7000);

            setTimeout(function () {
                AsgApp.loadChatProvider();
            }, 5000);

            resolve();
        });
    };

    const setGamesSubCategories = function (category) {
        let html = '';
        // eslint-disable-next-line no-param-reassign
        category = category || 0;
        const subCategories = Games.getSubCategories(category);
        const len = subCategories.length;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < len; i++) {
            const extraElement = subCategories[i].extraElement || null;
            html += Games.generateSubCategoryItem(subCategories[i].name, i, category, extraElement);
        }
        $('.games-menu-list').html(html);

        // Add sub-categories onclick event handler.
        gamesSubCategoriesOnClick();
    };

    const gamesSearchInit = function () {
        const gameSearch = $('.search-game input');
        const recentTitle = $('.recent');
        // Event handler - keyup, when user start searching games.
        gameSearch.on('keyup', function () {
            let searchVal = $(this).val();
            if (searchVal.length > 0) {
                searchVal = AsgApp.stripHtml(searchVal);
                recentTitle.hide();
                gamesSearchBuild($(this).parents('.search-game').find('.games-list'), searchVal);
            } else if (AsgFW.isMobilePamPlatform()) {
                $('.clear-search-mobile').trigger('click');
                $('.search-res-text').text(Dictionary.translate('searchResShow'));
            } else {
                $('.games-list').hide();
            }
        });

        // Event handler - click on cover screen.
        $('.cover-screen').on('click', function () {
            /**
             * Enable Scrolling
             */
            toggleDisableScrolling(false);

            if (isSmallDevice()) {
                slideMenu.close();
            } else {
                $('.search-game').css('z-index', '0');
            }
            $('body').removeClass('search-mode');
            $('.cover-screen').fadeOut('slow');
            $('.games-list').hide();
            $('.search-game input').val('');
        });

        // Event handler - focus on search string.
        gameSearch.on('focus', function () {
            $('.search-game').css('z-index', '999');
            $('body').addClass('search-mode');

            /**
             * Disable Scrolling
             */
            toggleDisableScrolling(true);

            const gameSearchParent = $(this).closest('.search-game');
            if (!gameSearchParent.hasClass('mob')) {
                $('.cover-screen').fadeIn('slow').css('height', $('body').height()).css('width', $('body').width());
            }
            const searchVal = $(this).val();
            if (searchVal.length > 0) {
                gamesSearchBuild($(this).parents('.search-game').find('.games-list'), searchVal);
            } else {
                $('.games-list').hide();
            }
        });

        // Event handler - on load games.
        $(document).on('loadGame', function () {
            toggleDisableScrolling(false);
            $('body').removeClass('search-mode');
            hideLoginBanner();
            Games.liveCasinoStop();
        });

        // Event handler - click on close mobile search.
        $('.close-search-mobile').on('click', function () {
            $('.search-game.mob').removeAttr('style');
            $('#main-container').removeAttr('style');
            fixMainContainerMargin();
            $('.search-game input').val('');
            $('.search-game.mob').hide();
            $('body').removeClass('search-mode');
            $('.search-game').data('was-opened', false);
            $('.search-res-text').text(Dictionary.translate('searchResShow'));
        });

        // Event handler - click on clear search string.
        $('.clear-search-mobile').on('click', function () {
            $('.search-game.mob input').val('');
            $('.search-game.mob .games-list').empty();
            addRecentlyPlayedGamesToGrid();
            $('.search-res-text').text(Dictionary.translate('searchResShow'));
        });
    };

    const showGameSearch = function () {
        $('.search-game').css({
            height: window.innerHeight - $('.main-menu-mobile').height() - $('.navbar').height(),
            'margin-right': '0px',
            'z-index': '1001',
            display: 'block',
        }).data('was-opened', true);
        $('#main-container').css({ height: $('.search-game').height() + $('.navbar').height(), overflow: 'hidden' });
        $('.mob-search-field  input').focus();
    };

    const gamesSearchBuild = function (gamesListDiv, searchVal) {
        // Prepare games HTML for the search request.
        let gameSearchHtml;
        if (AsgFW.isMobilePamPlatform()) {
            gameSearchHtml = Games.searchGameByName(searchVal, true, true, 'game_search_item_mobile', false);
            const resultCount = $(gameSearchHtml).filter('li.item').length;
            if (resultCount) {
                $('.search-res-text').html(`<span class="results-count">${resultCount} ${Dictionary.translate('resultsFor')} <span class="result-term">${searchVal}</span>`);
            } else {
                $('.search-res-text').find('.results-count').remove();
            }
            gameSearchHtml = $(gameSearchHtml).not('.results-count');
        } else {
            gameSearchHtml = Games.searchGameByName(searchVal, false, true, 'game_search_item', false);
        }

        // Process and show games.
        gamesListDiv.show();
        gamesListDiv.empty();
        gamesListDiv.append(gameSearchHtml);
        attachGamesThumbsEvents();
        AsgApp.setActionEvents('.games-list');
        loadImages();

        // Fix 'no games found' styles on mobile search page
        if ($('.games-list.games li').has('p').length === 1 && AsgFW.isMobilePamPlatform()) {
            $('.games-list.games li').css('width', '100%');
        }

        // Reset desktop search, after game was started from the search.
        if (!AsgFW.isMobilePamPlatform()) {
            $(gamesListDiv).on('click', function () {
                gamesListDiv.hide();
                $('.search-game input').val('');
            });
        }
    };

    const setTopGameStyle = function (singleGameHtml, gamesObj, counter, topGamesNumber) {
        let index = 7;
        if (AsgFW.isMobilePamPlatform() && AsgApp.isDoubleGameSize()) { index = 8; }

        if (counter < topGamesNumber) {
            if (counter > index && counter < 11) {
                gamesObj.bottom.push(Tools.replaceAll(singleGameHtml, '[extraclass-game]', 'no-show-md'));
                // eslint-disable-next-line no-param-reassign
                singleGameHtml = Tools.replaceAll(singleGameHtml, '[extraclass-game]', 'show-md');
            } else if (counter > 10) {
                gamesObj.bottom.push(Tools.replaceAll(singleGameHtml, '[extraclass-game]', 'no-show-lg'));
                // eslint-disable-next-line no-param-reassign
                singleGameHtml = Tools.replaceAll(singleGameHtml, '[extraclass-game]', 'show-lg');
            }
            gamesObj.top.push(Tools.replaceAll(singleGameHtml, '[extraclass-game]', ''));
        } else {
            gamesObj.bottom.push(Tools.replaceAll(singleGameHtml, '[extraclass-game]', ''));
        }
    };

    const createGamesHtml = function (games, topGamesFlag) {
        const topGamesHtml = [];
        gamesHtml = [];
        const gamesObj = { top: topGamesHtml, bottom: gamesHtml };
        let singleGameHtml = '';
        const colmd = 0;
        let counter = 0;
        let noDemoFlag = 0;
        let topGamesNumber = 14;
        let gamesLimit = 56;
        const allowedFlags = ['new', 'vip', 'free'];

        if (AsgFW.isMobilePamPlatform() && AsgApp.isDoubleGameSize()) {
            topGamesNumber = 11;
            gamesLimit = 59;
        }

        if (AsgApp.isNoDemoGamesCountry()) {
            noDemoFlag = 1;
        }

        let gameIndex = 0;
        Object.keys(games).every(i => {
            const game = Games.getGameDetails(games[i]);
            if (game) {
                if (AsgFW.isHideNetentGames() && game.externalGameProvider === 'NetEnt') {
                    return true;
                }

                singleGameHtml = Games.generateGameItem(game.id, game.name, game.images.default, game.images.webp, colmd, noDemoFlag, '', '', '', game.externalGameProvider, game.externalGameSubProvider);
                let singleGameHtmlColmd4 = Games.generateGameItem(game.id, game.name, game.images.default, game.images.webp, 4, noDemoFlag, '', '', '', game.externalGameProvider, game.externalGameSubProvider);
                if (Games.getGameFlagStatus(game) != null) {
                    const flagStatus = Games.getGameFlagStatus(game);
                    if (allowedFlags.indexOf(flagStatus.toLowerCase()) > -1) {
                        const statusFlag = `status-flag ${flagStatus.toLowerCase()} ${AsgApp.getLng().toLowerCase()}">${Dictionary.translate(`${flagStatus.toLowerCase()}Banner`)}`;
                        singleGameHtml = Tools.replaceAll(singleGameHtml, 'status-flag">', statusFlag);
                        singleGameHtmlColmd4 = Tools.replaceAll(singleGameHtmlColmd4, 'status-flag">', statusFlag);
                    }
                }

                singleGameHtml = AsgUI.filterDemoButtons(singleGameHtml, game);

                if (topGamesFlag) {
                    if (AsgFW.isMobilePamPlatform() && AsgApp.isDoubleGameSize()) {
                        gameIndex += 1;
                        if (gameIndex === 5) {
                            singleGameHtml = Tools.replaceAll(singleGameHtmlColmd4, '[extra-style]', 'data-screen-width="full"');
                            setTopGameStyle(singleGameHtml, gamesObj, counter, topGamesNumber);
                            gameIndex = 0;
                        } else {
                            setTopGameStyle(singleGameHtml, gamesObj, counter, topGamesNumber);
                        }
                    } else {
                        setTopGameStyle(singleGameHtml, gamesObj, counter, topGamesNumber);
                    }
                    counter += 1;
                    if (counter >= gamesLimit) {
                        return false;
                    }
                } else {
                    counter += 1;
                    if (counter <= gamesOpened) {
                        return true;
                    }
                    if (AsgFW.isMobilePamPlatform() && AsgApp.isDoubleGameSize()) {
                        gameIndex += 1;
                        if (gameIndex === 5) {
                            singleGameHtml = Tools.replaceAll(singleGameHtmlColmd4, '[extra-style]', 'data-screen-width="full"');
                            gamesObj.bottom.push(Tools.replaceAll(singleGameHtml, '[extraclass-game]', ''));
                            gameIndex = 0;
                        } else {
                            gamesObj.bottom.push(Tools.replaceAll(singleGameHtml, '[extraclass-game]', ''));
                        }
                    } else {
                        gamesObj.bottom.push(Tools.replaceAll(singleGameHtml, '[extraclass-game]', ''));
                    }
                    if (counter >= gamesLimit + gamesOpened) {
                        return false;
                    }
                }
            }
            return true;
        });

        if (counter < gamesLimit) {
            $('.close-games').hide();
            gamesOpened = counter;
        } else if (counter < gamesOpened + gamesLimit || counter === games.length) {
            $('.close-games').hide();
            gamesOpened += counter;
        } else {
            gamesOpened += gamesLimit;
            $('.close-games').show();
        }

        return gamesObj;
    };

    const gamesBuild = function (category, subcategory) {
        return new Promise((resolve) => {
            gamesOpened = 0;
            // eslint-disable-next-line no-param-reassign
            category = Number.isInteger(category) ? category : Games.getDefaultCategory();
            // eslint-disable-next-line no-param-reassign
            subcategory = subcategory || 0;
            const games = Games.getCategoryGamesWeb(category, subcategory);
            const gamesObj = createGamesHtml(games, true);

            $topGamesContainer.html('');

            let lastTopElement = '';
            let lastBottomElement = '';

            const topElementsTask = new Promise((resolve) => {
                gamesObj.top.forEach(gameTopElement => {
                    lastTopElement = gameTopElement;
                    // eslint-disable-next-line no-loop-func
                    setTimeout(() => {
                        $topGamesContainer.append(gameTopElement);
                        if (gameTopElement === lastTopElement) {
                            resolve();
                        }
                    }, 50);
                });
            });

            setTimeout(function () {
                attachGamesThumbsEvents();
                attachTickerEvents();
            }, 50);

            Promise.all([topElementsTask]).then(() => {
                loadImages();
                Tools.track('gamesGridRendered');
                Tools.log(`Games grid has been generated. categoryId - ${category}, subCategoryId - ${subcategory}`, null);
                resolve();
            });
        });
    };

    const gamesAdd = function (category, subcategory) {
        $('.close-games').hide();

        attachGamesThumbsEvents();
        loadImages();
    };

    const getGamesHtml = function () {
        return gamesHtml;
    };

    const attachGamesThumbsEvents = function (elem) {
        AsgApp.setActionEvents('.games');
        const elemName = elem || '.games';
        const lobbyGame = $(`${elemName} .game-item`);
        lobbyGame.off('click.mobilehover');
    };

    const switchMenu = function (status) {
        if (status === 'postLogin') {
            $('.log-in').hide();
            $('.log-out').show();
        } else {
            $('.log-in').show();
            $('.log-out').hide();
        }
    };

    // Fill mobile and web menu with Player's data
    const menuTitleUpdate = function () {
        const obj = ng_fw.getSessionDetails();
        if (Object.prototype.hasOwnProperty.call(obj, 'PlayerName')) {
            $('#account_details li a').first().text(obj.PlayerName); // Fill web menu
            AsgUI.NSBMenu.fillPostLoginData(); // Fill New Sidebar menu
        }
    };

    const hideLoadingScreen = function () {
        $('body').removeClass('loader-active');
        $('#loading-screen').hide();
    };

    const showLoadingScreen = function () {
        $('#loading-screen').fadeIn('slow');
    };

    const setLoyaltyPoints = function () {
        const obj = AsgApp.getLoyaltyPoints();

        // check if obj exist (some time not have loyalty parameter)
        if (obj) {
            const percents = obj.ProgressPercentForNextLevel;
            if (obj.PointsForNextLevel <= 0) {
                $('.points').hide();
                $('.stars').css('margin-top', '10px');
            } else {
                $('.reward-percent').text(`${percents}%`).css('width', `${parseInt(percents, 10)}%`);
                $('.points').show();
                $('.stars').css('margin-top', '0');
            }

            $('.reward-title').text(obj.LoyaltyLevelName);
            $('.rewards-stars-div').addClass(`stars-${obj.CurrentLevelNumber}`);
        }
    };

    const setDisplayBalance = () => {
        const RealBalance = AsgApp.getDisplayBalance().DisplayRealBalance;
        const BonusBalance = AsgApp.getDisplayBalance().DisplayBonusBalance;
        if (AsgApp.isSportActive() || AsgApp.isBrandDK()) {
            $('.user-balance.sum-span').text(RealBalance);
            $('.user-bonus.sum-span').text(BonusBalance);
        }
    };

    const getBannersLoopOptions = (isPnPDisabled) => {
        const mrRexCasinoId = '634';

        if (AsgFW.getBrandID() === mrRexCasinoId && AsgFW.isMobilePamPlatform()) {
            return {
                loop: false,
                rewind: true,
            };
        }

        return {
            loop: !!isPnPDisabled,
        };
    };

    let mobileWinnerTickerInit = function () {
        $('.mobile-winner-ticker-wrap').owlCarousel({
            ...getBannersLoopOptions(true),
            autoplay: true,
            center: true,
            autoplayTimeout: 3000,
            autoplayHoverPause: true,
            items: 1,
            nav: false,
            dots: false,
            responsive: {
                0: {
                    items: 2,
                },
                320: {
                    items: 3,
                },
                550: {
                    items: 4,
                },
                1000: {
                    items: 5,
                },
            },
        });
    };

    const hasWpSpecialEvent = function () {
        return Object.prototype.hasOwnProperty.call(appData, 'specialEventPreLoginWpLink')
                && Object.prototype.hasOwnProperty.call(appData.specialEventPreLoginWpLink, 'wp_special_event_banner')
                && appData.specialEventPreLoginWpLink.wp_special_event_banner !== '';
    };

    const hasWpInnerSideBanner = function () {
        return Object.prototype.hasOwnProperty.call(appData, 'specialEventPreLoginWpLink')
            && Object.prototype.hasOwnProperty.call(appData.specialEventPreLoginWpLink, 'wp_special_event_inner_side_banner')
            && appData.specialEventPreLoginWpLink.wp_special_event_inner_side_banner !== '';
    };

    const setWpInnerSideBanner = function () {
        const wpBannerSpecialElement = $('.inner-sidebanner img');

        wpBannerSpecialElement.removeAttr('data-action');
        wpBannerSpecialElement.removeAttr('data-action-info');

        if (!Player.isLoggedIn() && hasWpInnerSideBanner()) {
            const banner = {
                LinkType: 'E',
                TargetURL: appData.specialEventPreLoginWpLink.wp_special_event_inner_side_banner,
            };
            AsgApp.getbannerLinkType(banner, wpBannerSpecialElement);
            AsgApp.setActionEvents('.inner-sidebanner');
        } else {
            $('.bunner-inner-page').data('action', 'showDeposit');
            AsgApp.getbannerLinkType(' ', wpBannerSpecialElement);
            AsgApp.setActionEvents('.inner-sidebanner');
        }
    };

    const setPlayerLobbyBanners = function () {
        AsgApp.setActionEvents('.bunner-info-page');
        $('body').addClass('banners-active');
    };

    const attachTickerEvents = function () {
        $('.winner-content .winner-game-name').off('click');
        $('.winners-list li img').off('click');
        AsgApp.setActionEvents('.winners-list');
    };

    const setTickerGamesData = function () {
        const items = $('.winners-list li');
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < items.length; i++) {
            const gameNameElm = $(items[i]).find('.winner-game-name');
            const gameObj = Games.getGameByName(gameNameElm.text());
            const btn = $(items[i]).find('.play-game-btn');
            if (gameObj != null && AsgUI.isFilterNotPresentGames(gameObj.id)) {
                $(items[i]).find('img').attr('src', gameObj.images.default);
                gameNameElm.text(gameObj.name);
                const attr = $(items[i]).find('img').attr('data-action-info').replace('[gid]', gameObj.id);
                $(items[i]).find('.winner-content .winner-game-name').attr('data-action-info', attr);
                $(items[i]).find('img').attr('data-action-info', attr);
                $(items[i]).find('.winner-content .winner-game-name').data('actionInfo', attr);
                $(items[i]).find('img').data('actionInfo', attr);
                // replace fields for the play button
                if (btn.length) {
                    btn.val(Dictionary.translate('playNow'));
                    $(items[i]).find('.wrap').attr('data-action-info', attr).data('actionInfo', attr);
                    const evLab = `click ${gameNameElm.text()} ${AsgApp.getUserStatusText()} login`;
                    $(items[i]).find('.wrap').attr('data-ga-label', evLab);
                }
            } else {
                $(items[i]).remove();
            }
        }
    };

    const innerLinksInit = function () {
        const items = $('*[class^="asgapp-"]');
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < items.length; i++) {
            const classes = $(items[i]).attr('class').split(' ');
            // eslint-disable-next-line no-plusplus
            for (let j = 0; j < classes.length; j++) {
                if (classes[j].includes('asgapp-')) {
                    const attr = classes[j].split('asgapp-')[1];
                    $(items[i]).find('a').attr('data-action', attr);
                    $(items[i]).find('a').data('action', attr);
                    AsgApp.setActionEvents(`.${classes[j]}`);
                    break;
                }
            }
        }
    };

    const outerContactInit = function () {
        if (currentTemplate !== 'info.php') {
            return;
        }
        const removeItems = $('a[href*="HelpForgotPassword.aspx"]');
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < removeItems.length; i++) {
            $(removeItems[i]).attr('href', '#').attr('onclick', 'ng_fw.showForgotPassword()');
        }

        const items = $('a[href$="ContactUsMail.aspx"]');
        // eslint-disable-next-line no-plusplus
        for (let j = 0; j < items.length; j++) {
            $(items[j]).attr('data-action', 'showContactUs');
            $(items[j]).find('a').data('action', 'showContactUs');
        }
        AsgApp.setActionEvents('.StandardPageLeftSectionContentTable');
    };

    const specialBenefits = function () {
        const allPanels = (AsgApp.isBrandDK()) ? $('.special-benefits-accordion > .accordion-dd').show() : $('.special-benefits-accordion > .accordion-dd').hide();
        $('.special-benefits-accordion > .accordion-dt > a').on('click', function () {
            if ($(this).parent().next().is(':visible')) {
                allPanels.slideUp();
            } else {
                allPanels.slideUp();
                $(this).parent().next().slideDown();
            }
            return false;
        });
    };

    const setCookieCaretCategory = function (cat) {
        Cookie.create('user_category_selected', cat, '180', '/');
    };

    // eslint-disable-next-line no-extend-native
    String.prototype.replaceAll = function (target, replacement) {
        return this.split(target).join(replacement);
    };

    const setGameIdInPage = function (gameName, gameMode = 'D') {
        const gid = Games.getGameByName(gameName).id;
        InGame.setAttributes(null, null, null, 690);
        $('.game-page-load-game').attr('data-action-info', `${gid}|${gameMode}`);

        const img = $('.game-page-load-game.default').find('img');
        if (img) {
            const url = img.attr('src');
            if (url) {
                const temp = url.replaceAll('[gid]', gid);
                img.attr('src', temp);
            }
        }

        AsgApp.setActionEvents('#in-game-container-mobile');
    };

    const loadGameInPage = function (gameName, gameMode = 'D') {
        // Hide games for UK.
        if (AsgApp.isNoDemoGamesCountry() && !Player.isLoggedIn()) {
            return;
        }

        if (Games.getGameByName(gameName)) {
            const gid = Games.getGameByName(gameName).id;
            InGame.setAttributes(null, null, null, null);
            AsgApp.loadGame(`${gid}|${gameMode}|GP`);
        }
    };

    const isGamePage = function () {
        return currentTemplate === 'game-page.php';
    };

    const isHomePage = function () {
        return currentTemplate === 'page.php';
    };

    const isInView = function (elem) {
        const target = $(elem);
        const targetTop = target.offset().top;
        const targetHeight = target.height();
        const windowScroll = $(window).scrollTop();
        const windowHeight = $(window).height();

        return (targetTop - windowScroll < targetHeight + (windowHeight - 200));
    };

    const navigationQuickLinks = () => {
        $('.footer-quick-links.left-position > .menu-item:odd').detach().appendTo('.footer-quick-links.right-position');

        $('.footer-quick-links .menu-item.menu-item-has-children').click(function () {
            $('.footer-quick-links .menu-item.menu-item-has-children .collapse.in').not(this).collapse('toggle');
        });

        $(document).on('infoPageClicked', function () {
            $('.footer-quick-links .menu-item.menu-item-has-children .collapse.in').collapse('toggle');
        });
    };

    /**
     * close WalkThrough if with component opened
     */
    $('.item-myRewardPoints, .games-categories, .navbar-header .navbar-brand').on('click', function () {
        AsgApp.closeWalkThroughIfOpen();
    });

    /**
     * close WalkThrough by click on panic button
     */
    $('#in-game-container').on('click', '#panic-button-ingame .sb-slider', function () {
        AsgApp.closeWalkThroughIfOpen();
    });

    /**
     * after open buywin promotions stop Propagation
     */
    $('#imaginary-container').on('click', '.nsb-search-buywin', function () {
        AsgUI.hideOverlay();
    });

    /**
     * disable / enable Scrolling
     */
    let lastScrollYPosition = 0;
    let topPos = 0;
    const toggleDisableScrolling = (status) => {
        const body = $('body');
        if (status && body.hasClass('search-mode') && !AsgFW.isMobilePamPlatform()) {
            lastScrollYPosition = window.scrollY;
            topPos = lastScrollYPosition;

            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${topPos}px`;
        } else {
            document.body.style.top = 0;
            document.body.style.position = null;
            document.body.style.width = null;
            document.body.style.top = null;
            window.scrollBy(0, lastScrollYPosition);
        }
    };

    const getCurrentCategory = () => {
        const categories = AsgFW.getCategories();
        const category = categories[currentGamesCategory];
        if (category) {
            return category;
        }

        return null;
    };

    const renderCategoriesMenu = (categoryId) => {
        renderMobileCategoriesMenu();
        renderDesktopCategoriesMenu(categoryId);
    };

    const renderMobileCategoriesMenu = () => {
        let html = '';
        let categories = Games.getCategories();

        // If mobile and Recent is not already exists.
        if (AsgFW.isMobilePamPlatform() && categories.slice(-1)[0].name.toLowerCase() !== Dictionary.translate('recent').toLowerCase()) {
            categories = Games.addRecentGamesCategories(categories, Games.getDefaultCategory() + 1);
        }
        let i = 0;
        categories.forEach(function (cat) {
            const extraElement = cat.extraElement || null;
            html += Games.generateCategoryItem(cat.name, i, currentTemplate, extraElement);
            i += 1;
        });

        // Show mobile main verticals menu.
        if ($body.hasClass('has-skeleton')) {
            $gamesCategories.html('');
        }

        // Render main categories menu.
        $gamesCategories.html(html);

        // Mark the new category as active.
        markCurrentMobileCategory();

        // Add categories menu on click handler;
        $gamesCategories.find('li a').on('click', mobileCategoriesMenuOnClickHandler);
    };

    const renderDesktopCategoriesMenu = (categoryId) => {
        let htmlSubCats = '';
        const subCategories = Games.getSubCategories(categoryId);
        const len = subCategories.length;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < len; i++) {
            const extraElement = subCategories[i].extraElement || null;
            htmlSubCats += Games.generateSubCategoryItem(
                subCategories[i].name,
                i,
                categoryId,
                extraElement,
            );
        }
        $('.games-menu-list').html(htmlSubCats);

        // Mark the new category as active.
        markCurrentDesktopCategory();

        // Add categories menu on click handler;
        $('.games-menu-list li').on('click', desktopCategoriesMenuOnClickHandler);
    };

    const mobileCategoriesMenuOnClickHandler = (e) => {
        // Prevent links following.
        e.preventDefault();

        // Update Category Set with new values.
        const newCatId = parseInt(e.currentTarget.classList[0].replace('game-category-', ''), 10);
        AsgApp.setCurrentCategorySet({ categoryId: newCatId, subCategoryId: 0 });

        // Mark the new category as active.
        markCurrentMobileCategory();

        // Build the games grid for the chosen sub-category.
        const { categoryId, subCategoryId } = AsgApp.getCurrentCategorySet();
        gamesBuild(categoryId, subCategoryId).then(() => {
            sortStateUpdate(sortedCategoriesMap[categoryId][subCategoryId]);

            // Refresh Live casino.
            Games.liveCasinoRefresh();
        });
    };

    const desktopCategoriesMenuOnClickHandler = (e) => {
        // Update Category Set with new values.
        const { categoryId: subCatOrig } = AsgApp.getCurrentCategorySet();
        const newSubCatId = parseInt(e.currentTarget.id.replace('sub-', ''), 10);
        AsgApp.setCurrentCategorySet({ categoryId: subCatOrig, subCategoryId: newSubCatId });

        // Mark the new category as active.
        markCurrentDesktopCategory();

        // Build the games grid for the chosen sub-category.
        const { categoryId, subCategoryId } = AsgApp.getCurrentCategorySet();
        gamesBuild(categoryId, subCategoryId).then(() => {
            sortStateUpdate(sortedCategoriesMap[categoryId][subCategoryId]);

            // Scroll the games grid to the top.
            if ($('.games-menu')[0].getBoundingClientRect().top === 76) {
                const contentOffsetTop = Math.floor($('.content').offset().top);
                $('html, body').animate({
                    /*
                     * 114px - is the height of the header and categories menu.
                     * We will use the hardcoded values, as the new design will come soon.
                     */
                    scrollTop: contentOffsetTop - 114,
                }, 300);
            }

            // Refresh Live casino.
            Games.liveCasinoRefresh();
        });
    };

    const markCurrentMobileCategory = () => {
        const { categoryId } = AsgApp.getCurrentCategorySet();
        $gamesCategories.find('li a').removeClass('active');
        $gamesCategories.find(`li a.game-category-${categoryId}`).addClass('active');
    };

    const markCurrentDesktopCategory = () => {
        const { subCategoryId } = AsgApp.getCurrentCategorySet();
        $('.games-menu-list li').removeClass('active');
        $(`.games-menu-list #sub-${subCategoryId}`).addClass('active');
    };

    const setSportClasses = () => {
        document.body.classList.add(...sportClasses);
    };

    const clearSportClasses = () => {
        document.body.classList.remove(...sportClasses);
    };

    const hideBlocksBySelectors = (selectors) => {
        Array.from(document.querySelectorAll(selectors.join(','))).forEach((el) => {
            el.classList.add('hidden');
        });
    };

    const showBlocksBySelectors = (selectors) => {
        Array.from(document.querySelectorAll(selectors.join(','))).forEach((el) => {
            el.classList.remove('hidden');
        });
    };

    const renderVerticalContent = () => new Promise((resolve) => {
        if (AsgApp.isCasinoPageTemplate()) {
            setTimeout(function () {
                const { type: currentVerticalType } = AsgApp.getCurrentVertical();
                const verticals = AsgApp.getVerticals();
                const casinoBlocks = [
                    '.games-menu',
                    '.content',
                    '.mobile-winner-ticker-wrap',
                ];

                renderBalances();

                if (verticals.prevVerticalId !== verticals.currentVerticalId) {
                    AsgApp.setGameVerticalIdCookie(
                        currentVerticalType === AsgApp.verticalTypesEnum.SPORT
                            ? AsgFW.GameVerticalCodeToIdEnum.SPORT
                            : AsgFW.GameVerticalCodeToIdEnum.CASINO,
                    );

                    if (currentVerticalType !== AsgApp.verticalTypesEnum.SPORT) {
                        clearSportClasses();
                    }

                    if (currentVerticalType === AsgApp.verticalTypesEnum.SPORT) {
                        setSportClasses();
                    }

                    return resolve();
                }

                /*
                 * Render CASINO vertical.
                 */
                if (currentVerticalType === AsgApp.verticalTypesEnum.CASINO) {
                    showBlocksBySelectors(casinoBlocks);

                    const { categoryId, subCategoryId } = AsgApp.getCurrentCategorySet();
                    // Build games grid for proper cat/subcat.
                    gamesBuild(categoryId, subCategoryId);

                    // live casino start/refresh
                    Games.liveCasinoRefresh();

                    // Render categories menu
                    renderCategoriesMenu(categoryId);
                }

                if (currentVerticalType === AsgApp.verticalTypesEnum.SPORT) {
                    const { location } = AsgApp.getCurrentVertical();
                    const loadSport = () => {
                        // hide casino
                        hideBlocksBySelectors(casinoBlocks);
                        document.body.classList.add('sport-page', 'btobet-active');

                        const sportWrapElement = document.getElementById('sport-wrap');

                        // insert sport home wrap if not found in DOM
                        if (!sportWrapElement) {
                            const target = document.querySelectorAll('#main-container .content')[0];
                            const sportHomeWrapElement = document.createElement('div');
                            sportHomeWrapElement.id = 'sport-wrap';
                            target.insertAdjacentElement('afterend', sportHomeWrapElement);
                        }

                        SportUI.initSport('#sport-wrap', { pathname: location });
                    };

                    // if platform not loaded yet - we have to wait
                    if (!platformReady) {
                        // clean prev event listeners in case multiple clicks to same menu item
                        document.removeEventListener('asgReady', loadSport);

                        // load sport when platform will be ready
                        document.addEventListener('asgReady', loadSport);
                    } else {
                        // platform ready, load sport immediately
                        loadSport();
                    }
                }

                resolve();
            }, 50);
        } else if (AsgApp.isSportPageTemplate()) {
            renderSportBanners();
        }
    });

    const renderBalances = () => {
        setDisplayBalance();

        // rerender components with balance
        AsgUI.renderStatusBar();
        AsgUI.NewHeader.renderStatusBarSubheader();
        renderHeader();
    };

    const setNewGamePagePreferences = () => {
        if (AsgFW.isMobilePamPlatform()) {
            const baseHeaderHeight = 64;
            const baseSubMenuHeight = 44;
            const $bannerElement = $('.mobile-play-for-real-banner:not(.sticky-mobile-play-for-real-banner)');
            $(document).on('scroll', () => {
                const hasSubMenu = $('.main-menu-mobile').hasClass('remove-main-menu-mobile');
                const scrollTop = $(document).scrollTop();
                const topDistance = $bannerElement.offset().top - (hasSubMenu
                    ? baseHeaderHeight + baseSubMenuHeight
                    : baseHeaderHeight);
                if (scrollTop >= topDistance) {
                    $bannerElement.addClass('fixed');
                    $('.sticky-mobile-play-for-real-banner').addClass('fixed');
                } else {
                    $bannerElement.removeClass('fixed');
                    $('.sticky-mobile-play-for-real-banner').removeClass('fixed');
                }
            });
        }
    };

    // Public
    return {
        init,
        gamesBuild,
        getGamesHtml,
        attachTickerEvents,
        setPlayerLobbyBanners,
        getCurrentCategory,
        renderVerticalContent,
        renderDesktopCategoriesMenu,
    };
})();

/*** EXPORTS FROM exports-loader ***/
export {
  AppUI
};
